/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import EditIcon from '@mui/icons-material/Edit';
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators } from '../store/UploadDownloads';

interface Props {
    handleUploadDialogClick: Function
    selectedDownload: any
    UpdateEditDownloadData: Function
    handleDownloadModelCodeChange: Function
    enabled: any
}
class EditDownloads extends React.Component<Props>{
    handleEditClick = async () => {
        if (this.props.enabled) {
            await this.props.UpdateEditDownloadData(this.props.selectedDownload);
            await this.props.handleDownloadModelCodeChange(this.props.selectedDownload.downloadsClassificationModelCodeMapping);
            this.props.handleUploadDialogClick(true);
        }
    };
    render() {
        return (
            <div id="edit-button">
                <EditIcon className={this.props.enabled ? 'editColor' : 'disabledColor'} onClick={this.handleEditClick} style={{ cursor: 'pointer' }} />
            </div>
        );
    }
}
const mapStateToProps = (state: any) => ({
    selectedDownload: state.viewDownloads.selectedDownload
});

const mapDispatchtoProps = (dispatch: any) =>
    bindActionCreators(actionCreators, dispatch);

export default connect(
    mapStateToProps, mapDispatchtoProps
)(EditDownloads);
